/**
 * @file 中文水平测试
 * @author 丁聪
 */

import React, { Component } from 'react'
import { Why } from './components/index'
import { Footer } from '../../components/basic/index'
// import './index.scss'

class Chinese extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    return (
      <div>
        <Why />
        <Footer />
      </div>
    )
  }
}

export default Chinese
